import React, {useState, useCallback} from "react";
import {useEventListener} from "../../../../infrastructure/hooks/useEventListener";

export const ScrollButtonComposer = (Widget) => ({controller}) => {
  const [visible, setVisible] = useState(false);

  const handleIsVisible = useCallback((isVisible) => {
    controller.state.appState.scrollToTopButtonVisible = isVisible;
    setVisible(isVisible);
  }, []);

  const scrollToTop = useCallback(() => {
    controller.domUtils.scrollToTop();
  }, []);

  const onScroll = useCallback(() => {
    if (window.pageYOffset > 0 && !visible) {
      handleIsVisible(true);
    }

    if (window.pageYOffset === 0 && visible) {
      handleIsVisible(false);
    }
  }, [visible]);

  useEventListener('scroll', onScroll)

  const newProps = {
    scrollToTop: () => scrollToTop(),
    controller,
    visible
  };

  return <Widget {...newProps} />;
};
